<script lang="ts">
  import * as AlertDialog from '$lib/components/ui/alert-dialog';
  import type { Snippet } from 'svelte';

  interface Props {
    open?: boolean;
    handleOk?: any;
    title: string;
    description: string;
    richDescription?: Snippet;
    action2?: Snippet;
    cancelMsg?: string | null;
    confirmMsg: string;
  }

  let {
    open = $bindable(false),
    handleOk = () => {},
    title,
    description,
    richDescription,
    action2,
    confirmMsg,
    cancelMsg = null
  }: Props = $props();
</script>

<AlertDialog.Root bind:open>
  <AlertDialog.Content>
    <AlertDialog.Header>
      <AlertDialog.Title>{title}</AlertDialog.Title>
      <AlertDialog.Description>
        {#if !richDescription}
          {description}
        {:else}
          {@render richDescription()}
        {/if}
      </AlertDialog.Description>
    </AlertDialog.Header>
    <AlertDialog.Footer>
      <AlertDialog.Cancel
        >{#if cancelMsg}{cancelMsg}{:else}Cancel{/if}</AlertDialog.Cancel
      >
      {#if action2}
        {@render action2()}
      {/if}
      <AlertDialog.Action onclick={handleOk}
        >{#if confirmMsg}{confirmMsg}{:else}Ok{/if}</AlertDialog.Action
      >
    </AlertDialog.Footer>
  </AlertDialog.Content>
</AlertDialog.Root>
